<template>
  <div class="main">
    <div class="current-version-identifier"></div>
    
    <!-- Push-Notification-Banner für iOS -->
    <div v-if="showPushBanner" class="push-banner">
      <div class="push-banner-content">
        <span class="push-icon">🔔</span>
        <div class="push-text">
          <strong>Benachrichtigungen aktivieren?</strong>
          <p>Erhalte Updates bei Führungswechseln und neuen Nachrichten</p>
        </div>
        <button @click="enablePushNotifications" class="push-enable-btn">Aktivieren</button>
        <button @click="dismissPushBanner" class="push-dismiss-btn">×</button>
      </div>
    </div>
    
    <div class="match-container">
      <div class="select-container" v-if="!loading">
        <select name="selected-pool" class="selected-pool" v-model="selectedPool" @change="changedPool">
          <option v-for="pool in pools" :value="pool" :key="pool.id">{{ pool.name }}</option>
        </select>
        <!--<img src="@/assets/images/back.svg">-->
      </div>
      <LoadingSpinner v-if="loading" class="center-msg" message="Daten werden geladen..."/>
      <div class="main-container" v-if="!loading">
        <div class="success-modal" v-if="success_modal_visible">
          <div class="pyro">
            <div class="before"></div>
            <div class="after"></div>
          </div>
          <h2>Getränk wurde erfolgreich eingetragen!</h2>
          <p>Gute Arbeit. Das nächste wartet bestimmt schon.</p>
          <button @click="refreshPage()">Fertig</button>
        </div>
        <div class="enter-modal" v-if="enter_modal_visible && !success_modal_visible">
          <div class="back-button-container">
            <div>
              <button class="back-button" @click="resetModal();">
                <img src="@/assets/images/back.svg">
              </button>
              <p>Zurück</p>
            </div>
          </div>
          <h1>{{enter_modal_visible === 'drink' ? 'Getränk eintragen' : ''}}</h1>
          <form v-on:submit.prevent="submitModal" v-if="enter_modal_visible === 'drink'" style="max-height: 100%; overflow-y: scroll;">
            <div class="drink-type-container" v-if="!drinks && !selected_drink">
              <button class="single-drink-type" v-for="drink_type in drink_types" :key="drink_type.drink_type_id" @click="selectDrinkType(drink_type)">
                <img src="@/assets/images/beer.svg" v-if="drink_type.drink_type_name === 'Bier'">
                <img src="@/assets/images/wine.svg" v-if="drink_type.drink_type_name === 'Wein'">
                <img src="@/assets/images/drink.svg" v-if="drink_type.drink_type_name !== 'Wein' && drink_type.drink_type_name !== 'Bier'">
                <div class="drink-type-text">
                  <h2>{{drink_type.drink_type_name}}</h2>
                  <p>{{drink_type.count}} Verfügbar</p>
                </div>
              </button>
              <button class="single-drink-type" @click="selectDrinkType(null)">
                <img src="@/assets/images/drink.svg">
                <h2>Anderes</h2>
              </button>
            </div>
            <div class="drink-type-container" v-if="!!drinks && !selected_drink">
              <h2 v-if="drinks.length === 0">Dieser Getränketyp hat noch keine Getränke :(</h2>
              <router-link v-if="drinks.length === 0" to="/drinks" class="add-drink-redirect">Hier eintragen!</router-link>
              <button class="single-drink" v-for="drink in drinks" :key="drink.drink_id" @click="selectDrink(drink)">
                <div class="drink-name">
                  <h2>{{drink.drink_name}}</h2>
                </div>
                <div class="drink-stats">
                  <h4>Standards</h4>
                  <p><b>{{drink.drink_default_vol}}</b> %vol</p>
                  <p><b>{{drink.drink_default_ml}}</b> ml</p>
                </div>
              </button>
            </div>
            <div class="drink-info-container">
              <form v-on:submit.prevent="submitDrink" v-if="selected_drink" class="enter-drink-form">
                <h3 v-if="selected_drink !== 'other'">{{selected_drink.drink_name}}</h3>
                <label for="new-drink-name" v-if="selected_drink === 'other'"><p>Name</p></label>
                <div class="custom-input-container" v-if="selected_drink === 'other'">
                  <input type="text" id="new-drink-name" v-model="entered_drink.drink_name" autocomplete="off" @focus="show_suggestions = true" @blur="hideSuggestions">
                  <div class="suggestions-list frosted" v-if="show_suggestions && filteredSuggestions.length > 0">
                    <button type="button" v-for="suggestion in filteredSuggestions" :key="suggestion.drink_id" @click="selectSuggestion(suggestion)">
                      <p><b>{{suggestion.drink_name}}</b> (Standard)</p>
                    </button>
                  </div>
                </div>
                <label for="new-drink-default-ml"><p>ml</p></label>
                <input type="text" id="new-drink-default-ml" v-model="entered_drink.ml">
                <label for="new-drink-default-vol"><p>vol%</p></label>
                <input type="text" id="new-drink-default-vol" v-model="entered_drink.vol">
                <p><b>{{calculatePureAlcohol(entered_drink.ml, entered_drink.vol)}} g</b> reiner Alkohol</p>
                <button type="submit" :disabled="submitting"><p>{{submitting ? 'Wird gespeichert...' : 'Speichern 🍺'}}</p></button>
              </form>
            </div>
            <p v-if="modal_msg" class="error">{{modal_msg}}</p>
          </form>
        </div>

        <div class="sub-container" v-if="!enter_modal_visible">
          <div class="positivity" v-show="false">
            <span class="positivity__alone">Heute gehen wir</span>
            <div class="positivity__words">
              <span class="change">Dumm</span>
              <span class="change">Doof</span>
              <span class="change">Dämlich</span>
              <span class="change">Schlau</span>
            </div>
          </div>
        </div>
        <div class="sub-container" v-if="!enter_modal_visible">
          <h1>Ranking-Übersicht</h1>
          <LoadingSpinner v-if="stats_loading" class="center-msg" message="Statistiken werden berechnet..."/>
          <div class="rankings-wrapper">
            <div class="rankings">
              <div class="ranking" v-if="statistics && statistics.total_alcohol" @click="selectRanking('total_alcohol')">
                <h3>Reiner Alkohol</h3>
                <div class="standings">
                  <div v-for="(u, i) in statistics.total_alcohol.slice().splice(0,3)" :key="u.id" class="summary-line">
                    <div class="summary-medal-container">
                      <span class="summary-medal">{{i == 0 ? "🥇" : i == 1 ? "🥈" : "🥉"}}</span>
                      <span class="summary-name">{{(u.name ?? u.email)}}</span>
                    </div>
                    <span class="summary-val">{{u.alcohol_total}}g</span>
                  </div>
                </div>
              </div>
              <div class="ranking" v-if="statistics && statistics.total_ml" @click="selectRanking('total_ml')">
                <h3>Gesamtmenge</h3>
                <div class="standings">
                  <div v-for="(u, i) in statistics.total_ml.slice().splice(0,3)" :key="u.id" class="summary-line">
                    <div class="summary-medal-container">
                      <span class="summary-medal">{{i == 0 ? "🥇" : i == 1 ? "🥈" : "🥉"}}</span>
                      <span class="summary-name">{{(u.name ?? u.email)}}</span>
                    </div>
                    <span class="summary-val">{{u.ml_total / 1000}}L</span>
                  </div>
                </div>
              </div>
              <div class="ranking" v-if="statistics && statistics.total_drinks" @click="selectRanking('total_drinks')">
                <h3>Drinks Total</h3>
                <div class="standings">
                  <div v-for="(u, i) in statistics.total_drinks.slice().splice(0,3)" :key="u.id" class="summary-line">
                    <div class="summary-medal-container">
                      <span class="summary-medal">{{i == 0 ? "🥇" : i == 1 ? "🥈" : "🥉"}}</span>
                      <span class="summary-name">{{(u.name ?? u.email)}}</span>
                    </div>
                    <span class="summary-val">{{u.drinks_total}}</span>
                  </div>
                </div>
              </div>
              <div class="ranking" v-if="statistics && statistics.most_popular_drinks" @click="selectRanking('most_popular_drinks')">
                <h3>Top Drinks</h3>
                <div class="standings">
                  <div v-for="(u, i) in statistics.most_popular_drinks.slice().splice(0,3)" :key="u.log_drink_id" class="summary-line">
                    <div class="summary-medal-container">
                      <span class="summary-medal">{{i == 0 ? "🥇" : i == 1 ? "🥈" : "🥉"}}</span>
                      <span class="summary-name">{{(u.drink_name)}}</span>
                    </div>
                    <span class="summary-val">{{u.count}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="darken-page" v-if="selected_ranking && selected_ranking.headline && selected_ranking.data"></div>
          <div class="single-ranking-complete-container" v-if="selected_ranking && selected_ranking.headline && selected_ranking.data">
            <div class="single-ranking-complete">
              <div class="ranking-complete-headline-container">
                <button class="back-button" @click="clearSelectedRanking();">
                  <img src="@/assets/images/back.svg">
                </button>
                <h3>{{selected_ranking.headline}}</h3>
              </div>
              <div class="standings">
                <div v-for="(u, i) in selected_ranking.data" :key="u.id" class="ranking-item" :class="{ 'top-three': i < 3 }">
                  <div v-if="i < 3" class="rank-bg">{{ (i + 1).toString().padStart(2, '0') }}</div>
                  <div class="rank-content">
                    <div class="rank-name-container">
                      <span class="medal" v-if="i < 3">{{i == 0 ? "🥇" : i == 1 ? "🥈" : "🥉"}}</span>
                      <span class="rank-number" v-else>{{ i + 1 }}. </span>
                      <span class="user-name"><b>{{ (u.name ?? u.email) }}</b></span>
                    </div>
                    <span class="rank-val">{{ u.val }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="actions" v-if="!enter_modal_visible">
            <button class="action" @click="openEnterModal('drink')">
              <img src="@/assets/images/beer.svg">
              <h3>Eintragen</h3>
            </button>
            <router-link v-if="selectedPool && selectedPool.member_limit > 5" to="/dashboard" class="action secondary">
              <img src="@/assets/images/stats.svg">
              <h3>Statistik</h3>
            </router-link>
            <div v-else-if="selectedPool" class="action secondary locked" @click="$router.push('/pool-settings?pool=' + (selectedPool.pool_id || selectedPool.id))">
              <img src="@/assets/images/stats.svg">
              <h3>Statistik 🔒</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthService from '@/services/AuthService.js';
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import registerPushWorker, { requestPushPermission } from '@/registerServiceWorker';
export default {
  "name": "MatchView",
  data() {
    return {
      isAdmin: false,
      pools: null,
      details_expanded: false,
      nextProfiles: [],
      outOfProfiles: false,
      currentProfile: null,
      userHasNoProfile: false,
      hammertime: null,
      first_match: false,
      match_id: null,
      match: null,
      initialized: false,
      loading: false,
      enter_modal_visible: false,
      success_modal_visible: false,
      drink_types: null,
      selected_drink_type: null,
      drinks: null,
      selected_drink: null,
      entered_drink: {},
      submitting: false,
      stats_loading: true,
      statistics: null,
      selected_ranking: null,
      showPushBanner: false,
      all_pool_drinks: [],
      show_suggestions: false
    }
  },
  computed: {
    selectedPool: {
      get() {
        return this.$store.getters.getSelectedPool;
      },
      set(val) {
        this.$store.commit('SET_SELECTED_POOL', val);
      }
    },
    filteredSuggestions() {
      if (!this.entered_drink.drink_name || this.entered_drink.drink_name.length < 1) return [];
      const search = this.entered_drink.drink_name.toLowerCase();
      return this.all_pool_drinks.filter(d =>
          d.drink_name.toLowerCase().includes(search)
      ).slice(0, 5);
    }
  },
  components: {
    LoadingSpinner
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    },
    openEnterModal(type){
      this.enter_modal_visible = type
    },
    logDrink(type_id){
      console.log(type_id)
    },
    refreshPage(){
      this.$router.go();
    },
    clearSelectedRanking() {
      this.selected_ranking = null
    },
    selectRanking(type){
      this.selected_ranking = {
        headline: type === "total_alcohol" ? "Reiner Alkohol" : type === "total_ml" ? "Getrunkene Liter" : type === "total_drinks" ? "Drinks Total" : type === "most_popular_drinks" ? "Beliebteste Getränke" : "",
        data: this.statistics[type].map(s => {return {...s, name: type === "most_popular_drinks" ? s.drink_name : s.name, val: type === "total_ml" ? (s.ml_total / 1000) + " L" : type === "total_alcohol" ? (s.alcohol_total) + " g" : type === "total_drinks" ? s.drinks_total : s.count}})
      }
    },
    async selectDrinkType(type){
      this.selected_drink_type = type;
      if(!type){
        this.selected_drink = "other"
        this.entered_drink = { drink_name: '', ml: '', vol: '' }
        await this.getAllPoolDrinks();
      } else {
        await this.getDrinksOfSelectedType();
      }
    },
    selectDrink(drink) {
      this.selected_drink = drink;
      this.entered_drink.drink_id = drink.drink_id
      this.entered_drink.ml = drink.drink_default_ml
      this.entered_drink.vol = drink.drink_default_vol
    },
    selectSuggestion(drink) {
      this.selectDrink(drink);
      this.entered_drink.drink_name = null;
      this.show_suggestions = false;
    },
    hideSuggestions() {
      setTimeout(() => {
        this.show_suggestions = false;
      }, 200);
    },
    async getAllPoolDrinks() {
      if(this.selectedPool?.pool_id) {
        let response = await AuthService.getAvailableDrinks({pool_id: this.selectedPool.pool_id});
        if(response.success) {
          this.all_pool_drinks = response.msg;
        }
      }
    },
    resetModal(){
      this.enter_modal_visible = false;
      this.selected_drink_type = false;
      this.drinks = null;
      this.selected_drink = null;
    },
    async submitDrink() {
      this.submitting = true
      if(!this.entered_drink.vol || !this.entered_drink.ml || !(this.entered_drink.drink_name || this.selected_drink.drink_name)) {
        this.modal_msg = "Getränkename, ml und vol% Angabe sind erforderlich!"
        this.submitting = false
        return
      } else if (this.entered_drink.vol < 0 || this.entered_drink.ml < 0) {
        this.modal_msg = "Negative Werte gehen nicht du Schlingel"
        this.submitting = false
        return
      }

      try {
        let result = await AuthService.logDrink({
          pool_id: this.selectedPool.pool_id,
          log_drink_id: this.selected_drink.drink_id,
          user_id: this.$store.getters.getUser.id,
          log_vol: this.entered_drink.vol,
          log_ml: this.entered_drink.ml,
          log_alcohol_amount: this.calculatePureAlcohol(this.entered_drink.ml, this.entered_drink.vol),
          log_drink_name: this.entered_drink.drink_name ?? this.selected_drink.drink_name,
          timestamp: new Date().toLocaleString('en-CA', { timeZone: 'Europe/Berlin', hour12: false }).replace(',', '')
        })

        if(result.success) {
          this.success_modal_visible = true
        } else {
          this.msg = result.msg
        }
      } catch(e) {
        console.error(e)
        this.modal_msg = "API-Fehler: " + JSON.stringify(e.response.data.msg);
      }
      this.submitting = false
    },
    calculatePureAlcohol(ml, vol){
      // this is based on this: https://zsgw.rptu.de/campusplus/gesundheit/wissen/alkohol/promillerechner#:~:text=%2D%20In%20einem%20halben%20Liter%20Bier,6%20Gramm%20reiner%20Alkohol%20enthalten.
      return (ml && vol) ? Math.round(((ml * (vol / 100) * 0.8) + Number.EPSILON) * 100) / 100 : 0
    },
    async getAvailableDrinkTypes(){
      this.loading = true
      if(this.selectedPool?.pool_id) {
        let msg = await AuthService.getAvailableDrinkTypes({pool_id: this.selectedPool.pool_id});
        if(msg.success) {
          this.drink_types = msg.msg
        }
      }
      this.loading = false
    },
    async getDrinksOfSelectedType() {
      try {
        let response = await AuthService.getAvailableDrinksOfType({pool_id: this.selectedPool.pool_id, drink_type_id: this.selected_drink_type.drink_type_id});
        if(response.success) {
          this.drinks = response.msg.sort((a, b) => a.drink_name.localeCompare(b.drink_name))
          console.log(this.drinks)
        } else {
          this.modal_msg = response.msg
        }
      } catch(e) {
        console.error(e)
        this.modal_msg = "API-Fehler: " + JSON.stringify(e.response.data.msg);
      }
    },
    async getUserJoinedPools() {
      this.loading = true
      try {
        this.msg = await AuthService.getUserJoinedPools()
        if (this.msg.success && this.msg.msg.length > 0) {
          this.pools = this.msg.msg
          
          // Check if previously selected pool is still available
          const persistedPool = this.selectedPool;
          if (persistedPool) {
            const persistedId = persistedPool.pool_id || persistedPool.id;
            const found = this.pools.find(p => (p.pool_id || p.id) === persistedId);
            if (found) {
              this.selectedPool = found;
              return;
            }
          }
          
          // Fallback to first pool if none selected or not found
          this.selectedPool = this.msg.msg[0]
        } else {
          this.$router.push('/')
        }
      } catch (e) {
        console.error(e)
        this.errorMsg = e
      }
      this.loading = false
    },
    async getStats() {
      this.stats_loading = true
      try {
        let response = await AuthService.getPoolStatistics({pool_id: this.selectedPool.pool_id});
        if(response.success) {
          this.statistics = {...response.msg,
            total_alcohol: (response.msg.total_alcohol || [])
                .slice().sort((a, b) => b.alcohol_total - a.alcohol_total),
            total_ml: (response.msg.total_ml || [])
                .slice().sort((a, b) => b.ml_total - a.ml_total),
            total_drinks: (response.msg.total_drinks || [])
                .slice().sort((a, b) => b.drinks_total - a.drinks_total),
            most_popular_drinks: (response.msg.most_popular_drinks|| [])
                .slice().sort((a, b) => b.count - a.count)
          }
        } else {
          this.modal_msg = response.msg
        }
      } catch(e) {
        console.error(e)
        this.modal_msg = "API-Fehler: " + JSON.stringify(e.response.data.msg);
      }
      this.stats_loading = false
    },
    async changedPool() {
      this.initialized = false
      this.loading = true
      this.all_pool_drinks = []

      await this.getAvailableDrinkTypes()
      await this.getStats()

      this.initialized = true
      this.loading = false
    },
    async initializePushNotifications() {
      // Warten bis User interagiert hat (besser für Permission-Dialog)
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      const pushBannerDismissed = localStorage.getItem('pushBannerDismissed') === 'true';
      
      if (isIOS) {
        // Auf iOS nur wenn als PWA installiert
        console.log('🍎 iOS erkannt - prüfe PWA-Status...');
        const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
        
        if (!isStandalone) {
          console.warn('🍎 iOS: App nicht als PWA installiert. Push-Notifications übersprungen.');
          return;
        }
      }
      
      // Auf allen Plattformen: Zeige Banner falls noch keine Permission und nicht dismissed
      if (Notification.permission === 'default' && !pushBannerDismissed) {
        setTimeout(() => {
          this.showPushBanner = true;
        }, 1000);
      } else if (Notification.permission === 'granted') {
        if (this.$store.state.token) {
          console.log('📱 Initialisiere Push-Notifications...');
          await registerPushWorker();
        }
      }
    },
    // Manuelle Push-Aktivierung für iOS (User-initiated)
    async enablePushNotifications() {
      console.log('🔔 Manuelle Push-Aktivierung gestartet...');
      const success = await requestPushPermission();
      if (success) {
        this.showPushBanner = false;
      }
    },
    dismissPushBanner() {
      this.showPushBanner = false;
      // Optional: In localStorage merken dass User abgelehnt hat
      localStorage.setItem('pushBannerDismissed', 'true');
    }
  },
  async beforeCreate() {
    if (!this.$store.getters.isLoggedIn) {
      this.$router.push('/login');
    }
  },
  async mounted() {
    try {
      this.msg = await AuthService.getUser()
      this.isAdmin = !!this.msg.msg.isAdmin;
    } catch(e){
      console.error(e)
    }

    await this.getUserJoinedPools()
    await this.getAvailableDrinkTypes()
    await this.getStats()
    this.initialized = true;
    console.log("leck eier")
    
    // Push-Notifications nach erfolgreicher Initialisierung anfordern
    this.initializePushNotifications();
  }
}
</script>
<style scoped>
.main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  background: var(--background);
  padding: 20px 0 0 0;
  overflow-y: hidden;
}

h2, h3 {
  margin: 0;
  font-weight: 600;
}

h1 {
  font-size: 1.8rem;
  margin-bottom: 20px;
  text-align: center;
  width: 100%;
}

.match-container {
  height: 100%;
  max-height: 100%;
  width: 100%;
}

.main-container {
  overflow-y: auto;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 100px;
  box-sizing: border-box;
  max-height: 100%;
}

.sub-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  max-width: 600px;
  padding: 0 20px;
  box-sizing: border-box;
  max-height: 100%;
}

.rankings-wrapper {
  width: 100%;
  position: relative;
  overflow: hidden; /* Sicherstellen, dass nichts übersteht */
  margin-bottom: 20px;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}

/* 
  Fix: Statt mask-image (was oft backdrop-filter in Kindern bricht), 
  nutzen wir ein Overlay, das in die Hintergrundfarbe übergeht.
*/
.rankings-wrapper::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100px;
  background: linear-gradient(to bottom, transparent, var(--background));
  pointer-events: none;
  z-index: 10;
}

.rankings {
  padding: 10px 0 30px 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-gap: 15px;
  width: 100%;
  box-sizing: border-box;
  height: 100%; /* Wichtig: Füllt den Wrapper aus */
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.rankings .ranking {
  background: var(--glass-bg);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: var(--radius-m);
  padding: 18px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  justify-content: flex-start;
  border: 1px solid var(--border-color);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  box-sizing: border-box;
  width: 100%;
}

.rankings .ranking h3 {
  font-family: var(--font);
  font-weight: bold;
  color: var(--primary-color) !important;
}

.rankings .ranking:active {
  background: var(--active-bg);
  transform: scale(0.96);
}

.rankings .ranking:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0,0,0,0.15);
  border-color: var(--primary-color);
  background: var(--glass-bg);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
}

@media only screen and (max-width: 480px) {
  .rankings {
    grid-template-columns: 1fr;
  }

  .rankings .ranking:last-child {
  margin-bottom: 50px;
}
}

@media only screen and (min-width: 481px) {
   .rankings-wrapper::after {
    display: none;
  }
}

.rankings .ranking h3 {
  font-size: 1.2rem;
  color: var(--secondary-color);
  margin-bottom: 10px;
}

.rankings .ranking .standings {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  gap: 0;
}

.standings .summary-line:first-child .summary-name {
  font-size: 1rem;
  font-weight: bold;
}

.summary-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  font-size: 0.85rem;
  padding: 4px 4px;
  border-radius: 6px;
  box-sizing: border-box;
}

/*
[data-theme='dark'] .summary-line {
  background: rgba(255, 255, 255, 0.05);
}
*/

.summary-medal-container {
  display: flex;
}

.summary-medal {
  font-size: 1rem;
  margin-right: 4px;
  white-space: nowrap;
}

.summary-name {
  font-weight: 600;
  max-width: 180px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 8px;
}

.summary-val {
  font-weight: 800;
  color: var(--primary-color);
  opacity: 0.8;
}

.rankings .ranking .standings p b {
  font-weight: 600;
}

/* Select */
.select-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 10px;
}

.selected-pool {
  font-size: 1.5rem;
  font-family: var(--font);
  font-weight: 700;
  background: none;
  border: none;
  color: var(--primary-color);
  cursor: pointer;
  text-align: center;
  text-align-last: center;
}

.select-container img {
  transform: rotate(-90deg);
  width: 16px;
  height: 16px;
  opacity: 0.5;
}

/* Actions */
.actions {
  display: flex;
  width: 100%;
  margin-bottom: 30px;
  position: absolute;
  bottom: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  justify-content: center;
  gap: 15px;
  padding: 0 20px;
}

.actions .action {
  background: var(--primary-color);
  border-radius: var(--radius-l);
  display: flex;
  flex-direction: row; /* Changed to row */
  align-items: center;
  justify-content: center;
  gap: 15px;
  padding: 18px;
  color: var(--text-on-primary);
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  transition: transform 0.2s;
  width: fit-content;
  text-decoration: none;
}

.actions .action.secondary {
  background: var(--glass-bg);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid var(--border-color);
  color: var(--primary-color);
}

.actions .action.secondary img {
  filter: var(--icon-filter);
}

.actions .action.secondary h3 {
  color: var(--primary-color);
}

.actions .action.secondary.locked {
  opacity: 0.6;
  position: relative;
  overflow: hidden;
}

.actions .action.secondary.locked::after {
  content: "PREMIUM";
  position: absolute;
  top: 0;
  right: 0;
  background: var(--warning);
  color: white;
  font-size: 0.5rem;
  padding: 2px 8px;
  font-weight: 800;
  border-bottom-left-radius: 6px;
}

.actions .action:active {
  transform: scale(0.97);
}

.actions .action img {
  width: 24px;
  height: 24px;
  filter: var(--icon-filter-invert);
}

.actions .action h3 {
  color: var(--text-on-primary);
  font-size: 1.1rem;
  margin: 0;
}

.h-game-btn {
  background: linear-gradient(135deg, #ff9800, #ff5722) !important;
}

.h-game-icon {
  font-size: 1.5rem;
  font-weight: 800;
  color: white;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Modal */
.enter-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  background: var(--background);
  z-index: 2000;
  display: flex;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;
}

.enter-modal h1 {
  font-size: 2rem;
  margin: 20px 0;
}

.enter-modal p {
  color: var(--tertiary-color);
  font-size: 1rem;
  margin-bottom: 20px;
}

.enter-modal .back-button-container {
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-start;
}

.enter-modal .back-button-container p {
  color: var(--primary-color);
  margin: 0 0 4px 0;
}

.enter-modal .back-button-container > div {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.enter-modal .back-button img {
  width: 24px;
  height: 24px;
}

.enter-modal .drink-type-container {
  display: flex; /* grid to flex column for better list */
  flex-direction: column;
  gap: 10px;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  overflow-y: auto;
  padding-bottom: 50px;
}

.single-drink-type, .single-drink {
  background: var(--background-secondary);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
  border-radius: var(--radius-m);
  padding: 15px 20px;
  border: none;
  width: 100%;
  box-sizing: border-box;
  transition: background 0.2s;
}

.single-drink {
  justify-content: space-between !important;
}

.single-drink-type:active, .single-drink:active {
  background: var(--active-bg);
}

.single-drink-type img, .single-drink img {
  width: 32px;
  height: 32px;
  filter: var(--icon-filter);
  opacity: 0.8;
}

.single-drink-type .drink-type-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-grow: 1;
}

.single-drink-type h2, .single-drink h2 {
  font-size: 1.1rem;
  color: var(--primary-color);
}

.single-drink-type p {
  margin: 0;
  font-size: 0.85rem;
}

.drink-stats {
  text-align: right;
}

.drink-stats p, .drink-stats h4 {
  font-size: 0.85rem;
  margin: 0;
}

.enter-drink-form {
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-width: 600px;
  width: 100%;
  margin: 0 auto;
}

.enter-drink-form label p {
  margin: 0;
  text-align: left;
}

.enter-drink-form input {
  font-family: var(--font);
  color: var(--primary-color);
  font-size: 1.2rem;
  padding: 15px;
  background: var(--background-secondary);
  border: none;
  border-radius: var(--radius-m);
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 6px;
}

.enter-drink-form button[type=submit] {
  background: var(--primary-color);
  color: var(--text-on-primary);
  padding: 18px;
  border-radius: var(--radius-l);
  font-size: 1.1rem;
  width: 100%;
  margin-top: 20px;
}

/* Success Modal */
.success-modal {
  background: var(--background);
  border: 1px solid var(--border-color);
  width: 90%;
  max-width: 400px;
  border-radius: var(--radius-l);
  padding: 40px 20px;
  z-index: 2500;
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0 10px 50px rgba(0,0,0,0.2);
  align-items: center;
  text-align: center;
}

.success-modal button {
  background: var(--primary-color);
  color: var(--text-on-primary);
  padding: 15px 30px;
  border-radius: 100px;
  font-size: 1rem;
}

/* Rankings Overlay */
.single-ranking-complete-container {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 3000;
  justify-content: center;
  align-items: flex-end; /* Sheet style */
}

.darken-page {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.4);
  backdrop-filter: blur(5px);
}

.single-ranking-complete {
  background: var(--background);
  width: 100%;
  max-width: 600px;
  height: 85vh;
  border-top-left-radius: var(--radius-l);
  border-top-right-radius: var(--radius-l);
  padding: 20px;
  z-index: 3001;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow-y: auto;
}

.ranking-complete-headline-container {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.ranking-complete-headline-container h3 {
  font-size: 1.5rem;
  margin-left: 10px;
}

.single-ranking-complete .standings {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 40px;
}

.ranking-item {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 12px;
  border-bottom: 1px solid var(--border-color);
  width: 100%;
  box-sizing: border-box;
  transition: all 0.2s ease;
}

.ranking-item.top-three {
  padding: 28px 16px;
  border-bottom: none;
  margin-bottom: 4px;
  background: var(--background-secondary);
  border-radius: var(--radius-m);
  overflow: hidden;
}

.ranking-item.top-three:nth-child(1) {
  background: linear-gradient(135deg, rgba(255, 215, 0, 0.1) 0%, var(--background-secondary) 100%);
}

.ranking-item.top-three:nth-child(2) {
  background: linear-gradient(135deg, rgba(192, 192, 192, 0.1) 0%, var(--background-secondary) 100%);
}

.ranking-item.top-three:nth-child(3) {
  background: linear-gradient(135deg, rgba(205, 127, 50, 0.1) 0%, var(--background-secondary) 100%);
}

.rank-bg {
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 5.5rem;
  font-weight: 900;
  color: var(--primary-color);
  opacity: 0.05;
  font-style: italic;
  z-index: 0;
  pointer-events: none;
  line-height: 1;
  letter-spacing: -5px;
}

.rank-content {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.rank-name-container {
  display: flex;
  align-items: center;
  gap: 12px;
}

.medal {
  font-size: 1.5rem;
  filter: drop-shadow(0 2px 4px rgba(0,0,0,0.1));
}

.rank-number {
  color: var(--tertiary-color);
  font-weight: 700;
  font-size: 1rem;
  min-width: 28px;
}

.top-three .rank-number {
  color: var(--primary-color);
  font-size: 1.2rem;
}

.user-name {
  font-size: 1.1rem;
  color: var(--primary-color);
  
  max-width: 180px;
  display: inline-block;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.rank-val {
  font-weight: 800;
  font-size: 1rem;
  color: var(--primary-color);
  background: var(--background);
  padding: 6px 14px;
  border-radius: 100px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.06);
}

.center-msg {
  margin-top: 50%;
  max-width: 80vw;
}

/* Other */
.link-button {
  background: var(--background-secondary);
  padding: 12px 20px;
  color: var(--primary-color);
  text-decoration: none;
  border-radius: 50px;
  font-size: 1rem;
  margin-top: 20px;
  display: inline-block;
}

.pyro > .before, .pyro > .after {
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  box-shadow: 0 0 #fff;
  animation: 1s bang ease-out infinite backwards, 1s gravity ease-in infinite backwards, 5s position linear infinite backwards;
}
    
.pyro > .after {
  animation-delay: 1.25s, 1.25s, 1.25s;
  animation-duration: 1.25s, 1.25s, 6.25s;
}
        
@keyframes bang {
  to {
    box-shadow: -100px -100px #f00, 100px -100px #0f0, 0 -200px #00f;
    opacity: 0;
  }
}
    
@keyframes gravity {
  to {
    transform: translateY(200px);
    opacity: 0;
  }
}
    
@keyframes position {
  0%, 100% { margin-top: 10%; margin-left: 40%; }
  50% { margin-top: 40%; margin-left: 30%; }
}

/* Push-Notification-Banner */
.push-banner {
  margin: 10px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  animation: slideIn 0.3s ease-out;
}

.push-banner-content {
  display: flex;
  align-items: center;
  padding: 16px;
  color: white;
  position: relative;
}

.push-icon {
  font-size: 24px;
  margin-right: 12px;
  flex-shrink: 0;
}

.push-text {
  flex: 1;
  margin-right: 12px;
}

.push-text strong {
  display: block;
  font-size: 16px;
  margin-bottom: 4px;
}

.push-text p {
  font-size: 13px;
  margin: 0;
  opacity: 0.9;
}

.push-enable-btn {
  background: white;
  color: #667eea;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.push-enable-btn:hover {
  transform: scale(1.05);
}

.push-dismiss-btn {
  background: none;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
  padding: 4px 8px;
  margin-left: 8px;
  opacity: 0.8;
  border-radius: 50%;
  transition: opacity 0.2s ease;
}

.push-dismiss-btn:hover {
  opacity: 1;
  background: rgba(255, 255, 255, 0.1);
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.custom-input-container {
  position: relative;
  width: 100%;
}

.suggestions-list {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 100;
  background: var(--background-secondary);
  border-radius: var(--radius-m);
  margin-top: 5px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0,0,0,0.15);
  border: 1px solid var(--border-color);
}

.suggestions-list button {
  width: 100%;
  padding: 12px 15px;
  text-align: left;
  background: none;
  border: none;
  border-bottom: 1px solid var(--border-color);
  cursor: pointer;
  transition: background 0.2s;
}

.suggestions-list button:last-child {
  border-bottom: none;
}

.suggestions-list button:active {
  background: var(--active-bg);
}

.suggestions-list p {
  margin: 0;
  font-size: 0.95rem;
  color: var(--primary-color);
}
</style>
